module.exports = __webpack_public_path__ + "img/inland_hillside.36106ed3.jpg";